import sps from "../../assets/images/header/sps.svg";
import planvsactuals from "../../assets/images/header/planvsactuals.svg";
import dpi from "../../assets/images/header/dpi.svg";
import aglieOR from "../../assets/images/header/aglieOR.svg";
import ccc from "../../assets/images/header/ccc.svg";
import manpower from "../../assets/images/header/manpower.svg";
import oranalystics from "../../assets/images/header/oranalystics.svg";
import AIIcon from "../../assets/images/chat_AI_icon.svg";
import rmpmengine from "../../assets/images/header/rmpmengine.svg";
import si from "../../assets/images/header/si.svg";
import ir from "../../assets/images/header/ir.svg";
import home from "../../assets/images/home-icon.svg";

export const MenuList = [
  // {
  //     title: "Home",
  //     icon: home,
  //     path: "/samarth",
  //     menus: [],
  // },
  {
    label: "AS",
    description: "Alert Summary",
    menus: [
      {
        title: "RMPM Summary",
        icon: rmpmengine,
        path: "/samarth/alert_summary",
      },
    ],
  },
  {
    label: "DPS",
    description: "Daily Production Scheduler",
    menus: [
      {
        title: "Smart Production Scheduler",
        icon: sps,
        path: "/samarth/smart_production_scheduler",
      },
      {
        title: "DPR(Plan VS Actual)",
        icon: planvsactuals,
        path: "/samarth/plan_vs_actuals",
      },
      {
        title: "Prioritization matrix",
        icon: dpi,
        path: "/samarth/priortization_matrix",
      },
      {
        title: "Daily Phasing insight",
        icon: ir,
        path: "/samarth/daily_production_insights",
      },
    ],
  },
  {
    label: "RMPM",
    description: "RMPM shortage epic",
    menus: [
      {
        title: "RMPM Autonomous Engine",
        icon: rmpmengine,
        type: "RMPM Alert",
        path: "/samarth/alert_details",
      },
      {
        title: "Cognitive Contract Coverage",
        icon: ccc,
        path: "/samarth/contract_alert",
      },
      {
        title: "RMPM Analytics",
        icon: ir,
        path: "/samarth/norm_alert",
      },
      {
        title: "Supplier Collaboration Agent",
        icon: si,
        path: "/samarth/supplier_insights",
      },
    ],
  },
  {
    label: "MD",
    description: "Manufacturing disruption epic",
    menus: [
      {
        title: "Agile OR",
        icon: aglieOR,
        path: "/samarth/agile_or",
      },
      {
        title: "OR Analytics",
        icon: oranalystics,
        path: "/samarth/weekly_or",
      },
      {
        title: "Manpower Shortage",
        icon: manpower,
        path: "/samarth/manpower_shortage",
      },
    ],
  },
  {
    label: "PS",
    description: "FG Stock Out epic",
    menus: [
      {
        title: "Order To Delivery Hub",
        icon: aglieOR,
        path: "/samarth/order_to_delivery_hub",
      },
      {
        title: "Loss To Action Engine",
        icon: oranalystics,
        path: "/samarth/loss_to_action_engine",
      },
      {
        title: "NR Replenishment Engine",
        icon: aglieOR,
        path: "/samarth/nr_replenishment_engine",
      },
    ],
  },
  {
    label: "QC",
    description: "Quick Comm epic",
    menus: [
      {
        title: "Hands Free VMI",
        icon: aglieOR,
        path: "/samarth/order_visibility",
      },
      {
        title: "Disptach Priority",
        icon: oranalystics,
        path: "/samarth/dispatch_priority",
      },
      {
        title: "PO Priority",
        icon: manpower,
        path: "/samarth/po_priority",
      },
    ],
  },
  {
    label: "EA",
    description: "External Links",
    menus: [
      {
        title: "Everstream",
        path: "https://eur01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fapp.eu1.apps.everstream.ai%2Fincidents&data=05%7C02%7CFalguni.Agrawal%40unilever.com%7C651169dd13b04a8b94ac08de1bab9ea4%7Cf66fae025d36495bbfe078a6ff9f8e6e%7C1%7C0%7C638978621063626977%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=cfsID9V%2BavA9XHIEPmaNT38QbvwFRxU0fHVR41RSzvQ%3D&reserved=0",
        external: true,
      },
      {
        title: "Grid Eye",
        path: "https://app.superprocure.com/tripBoard?tab=Indent&branchIds=1447505&fromDate=16%2F02%2F2026&toDate=18%2F03%2F2026",
        external: true,
      },
      {
        title: "Capacity Master",
        path: "https://unilever-my.sharepoint.com/shared?id=%2Fsites%2FSamarth%2DManualMasters%2FShared%20Documents%2FSCNC%5FDaily%5FPhasing%5FMasterData%2FSamarth%20%28SCNC%29%20%2D%20Daily%20Phasing%20Master%20Data&listurl=https%3A%2F%2Funilever%2Esharepoint%2Ecom%2Fsites%2FSamarth%2DManualMasters%2FShared%20Documents&OR=Teams%2DHL&CT=1768213442472&TeamsCID=7be58174%2D3d4a%2D4948%2Dabea%2Dab6a776318bf&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNjA1MTQxNjcxMyIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D&xsdata=MDV8MDJ8fGY2MTcwYzI1ZDgyYTQ3ZGI1ZjdiMDhkZWM1NDhkMGE0fGY2NmZhZTAyNWQzNjQ5NWJiZmUwNzhhNmZmOWY4ZTZlfDB8MHw2MzkxNjUxMTM2NjE5Mzk1Nzl8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKRFFTSTZJbFJsWVcxelgwRlVVRk5sY25acFkyVmZVMUJQVEU5R0lpd2lWaUk2SWpBdU1DNHdNREF3SWl3aVVDSTZJbGRwYmpNeUlpd2lRVTRpT2lKUGRHaGxjaUlzSWxkVUlqb3hNWDA9fDF8TDJOb1lYUnpMekU1T2pCbU5EUXlPVEZoTFdVM1ptSXRORGM0T1MxaE5HVTBMVEJtT0dObE1Ea3lNR001T1Y4M00ySTFOMk13TlMwd09ERmlMVFExT0RFdFlUbGxNeTB3TldObU1UVTNOV1U1TVdWQWRXNXhMbWRpYkM1emNHRmpaWE12YldWemMyRm5aWE12TVRjNE1Ea3hORFUyTkRneE13PT18NzY1M2E5ZTAwOWUzNDMyZGZkMDUwOGRlYzU0OGQwYTF8NDk3ZDc4YmRhNjU0NDdjNTkwNjNlMDAwM2M2MDBiYzA%3D&sdata=N1UwTkJkQ3dZYmpMUXI4UHo5TkpFMVVaVWN2OXFucExiUXBTUFRmaVcvaz0%3D&ovuser=f66fae02-5d36-495b-bfe0-78a6ff9f8e6e%2CAbhijeet.Sahu%40unilever.com",
        external: true,
      },
    ],
  },
  {
    label: "",
    description: "Samarth AI",
    menus: [
      {
        icon: AIIcon,
        title: "Samarth AI",
        path: "/samarth/chat",
        external: true,
      },
    ],
  },
];
